import * as AT from "./actionTypes";

export const setFlash = (flashType: string, message: string, metaData?: any, persistent?: boolean) => ({
    type: AT.GENERAL_SET_FLASH,
    meta: metaData,
    payload: {
        type: flashType,
        message: message,
        ...(persistent ? { persistent } : {}),
    },
});

export const setNegativeFlash = (message: string, metaData?: any, persistent?: boolean) =>
    setFlash("negative", message, metaData, persistent);
export const setPositiveFlash = (message: string, metaData?: any, persistent?: boolean) =>
    setFlash("positive", message, metaData, persistent);
export const setWarningFlash = (message: string, metaData?: any, persistent?: boolean) =>
    setFlash("warning", message, metaData, persistent);
export const setInfoFlash = (message: string, metaData?: any, persistent?: boolean) =>
    setFlash("info", message, metaData, persistent);

/** `force` clears the flash even if it's persistent, e.g. when the user manually dismisses it. */
export const clearFlash = (force?: boolean) => ({
    type: AT.GENERAL_CLEAR_FLASH,
    payload: { force },
});

export const showGlobalModal = (modalName: string) => ({
    type: AT.GENERAL_SHOW_GLOBAL_MODAL,
    payload: {
        [modalName]: true,
    },
});
